;(function () {
    HomeCtrl.$inject = ['$http', '$q', 'request'];
    angular.module('DSSXAPP', ['app.core']);

    angular
        .module('DSSXAPP')
        .controller('HomeCtrl', HomeCtrl)

    function HomeCtrl($http, $q, request) {

        var vm = this;

        vm.catFirstListAll = []; // 所有一级类目
        vm.popularStore = {
            list: [],
            hid: ''
        }; // 热门店铺
        vm.selectProducts = {
            list: [],
            hid: ''
        }; // 特定产品
        vm.recentViewProductAll = []; // 最近預覽的產品
        vm.selectPBoxWidth = null; // selected products 显示图片区域宽度
        vm.topSBoxWidth = null; // top selected suppliers 显示图片区域宽度
        vm.recentViewListWidth = null; // recent view product 显示图片区域宽度
        vm.getGivenProduct = getGivenProduct;
        vm.selectProLoading = false;

        vm.f = {
            getSomeBoxWidth: getSomeBoxWidth,
            gotoTop: gotoTop
        }

        var selectPBox = $('#product-list-box')[0];
        var topSBox = $('#t-s-product-list-box')[0];
        var recentPBox = $('#r-v-product-box')[0];
        var token = DSSX.util.getToken();
        var bodyDom = $('html,body');
        // var recentViewPs = [];

        window.onresize = onResize;
        // ==============function=====================

        init();

        function init() {
            getProductCatF();
            getGivenProduct('Apparel');
            getPopularStore();
            loadRecentView();
            // handleRecentView();
            // vm.recentViewProductAll = getTempStorage('recentViewList');
            // console.log('recentView', vm.recentViewProductAll);
        }

        /**
         * http request get
         * @param url
         * @param params
         * @param successCallback
         */
        function sendHttpGet(url, params, needLogin, successCallback) {
            needLogin = needLogin || false;
            request.get(url, params, needLogin).then(success, error);

            function success(res) {
                res.data = res.data || {};
                successCallback(res.data);
            }

            function error(err) {
                DSSX.dialog.err(err, {
                    moduleName: 'aliIndex.js',
                    funcName: 'sendHttpGet',
                    text: 'sendHttpGet fail'
                });
            }

        }

        function sendHttpPost(url, data, successCallback) {
            return request.post(url, {}, data, true).then(success, error);

            function success(res) {
                res.data = res.data || {};
                successCallback(res.data);
            }

            function error(err) {
                DSSX.dialog.err(err, {
                    moduleName: 'aliIndex.js',
                    funcName: 'sendHttpPost',
                    text: 'sendHttpPost fail'
                });
            }
        }

        /**
         * 获得一级类目菜单
         */
        function getProductCatF() {
            var url = '/pub/api/productCat?level=1';

            sendHttpGet(url, {}, false, success);

            function success(data) {
                vm.catFirstListAll = data;
            }
        }

        /**
         * 获得热门店铺
         */
        function getPopularStore() {
            var url = '/pub/api/popularStore?limit=30';

            sendHttpGet(url, {}, true, success);

            function success(data) {
                var list = data.stores || [];
                vm.popularStore = {
                    list: list,
                    hid: data.hid || ''
                };
            }
        }

        /**
         * 根据类目获取产品
         * @param cate
         */
        function getGivenProduct(cate) {
            var params = {
                hotProdCount: {
                    mainCate: cate
                }
            };

            vm.selectProLoading = true;
            sendHttpPost('/pub/api/loadData', params, success);

            function formatProduct(arg_data) {
                var res = [];

                Array.isArray(arg_data) && arg_data.forEach(function (v, k) {
                    this.push(DSSX.util.safe(v, 'hotProds', {}));
                }, res);

                return res;
            }

            function success(data) {
                var list = formatProduct(DSSX.util.safe(data, 'hotProdCount.result.' + cate, []));
                vm.selectProducts = {
                    list: list,
                    hid: data.hid || ''
                };
                vm.selectProLoading = false;
            }

        }

        /**
         * 更新需要偏移图片位置的box宽度
         */
        function onResize() {
            vm.selectPBoxWidth = selectPBox.offsetWidth;
            vm.topSBoxWidth = topSBox.offsetWidth;
            vm.recentViewListWidth = recentPBox.offsetWidth;
        }

        /**
         * 页面加载完成获得滚动图片区域宽度
         */
        function getSomeBoxWidth() {
            onResize();
        }

        function gotoTop() {
            bodyDom.animate({'scrollTop': 0}, 500);
        }

        /**
         * 列出产品浏览记录
         */
        function loadRecentView() {
            var url = '/pub/api/listBrowseHistory';
            var params = {
                limit: 16
            };

            sendHttpGet(url, params, true, success);

            function success(data) {
                var result = [];
                var list = data.products || [];
                for (var i = 0; i < list.length; i++) {

                    var img = '';
                    if (list[i].imgs.length) {
                        img = list[i].imgs[0].url || '';
                    }

                    var p = {
                        id: list[i].id,
                        prodDetailUrl: DSSX.util.getNeedCountClickPageUrl(list[i].id, data.hid, 'BROWSER_HISTORY', 'prod'),
                        img: DSSX.util.safe(list[i], 'imgs.0.url', '') + '/small'
                    };
                    result.push(p);
                }
                vm.recentViewProductAll = result;
            }
        }

    }

})();